import { render } from "./sending_statistics.view.vue?vue&type=template&id=57d8367d"
import script from "./sending_statistics.view.vue?vue&type=script&lang=js"
export * from "./sending_statistics.view.vue?vue&type=script&lang=js"

import "./sending_statistics.view.vue?vue&type=style&index=0&id=57d8367d&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__